import { render } from "./ToggleSwitch.vue?vue&type=template&id=727887ab&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=727887ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727887ab"]])

export default __exports__